import css from './transaction.module.scss';
import {TransactionProps} from './transaction.types';

export const Transaction = (props: TransactionProps): JSX.Element => {
	const sign =
		props.type === 'increase' ? (
			<span style={{color: 'RGB(52, 199, 89)'}}>+</span>
		) : (
			<span style={{color: 'RGB(244, 66, 55)'}}>-</span>
		);

	return (
		<div onClick={() => props.onClick(props.time)} className={css.container}>
			<div className={css.imageContainer}>
				<img width={40} src={props.img} />
			</div>
			<div>
				<div>
					{sign}
					{props.value} SET
				</div>
				<div className={css.time}>{props.time}</div>
			</div>
			<div className={css.arrow}>
				<img src="/img/arrowLeft.svg" />
			</div>
		</div>
	);
};
